import { Column, Columns } from '@codeparva/ui-components-library';
import React from 'react';
import { weakKey } from '../../../../../utilities/weakKey';
import { DynamicFormTypes } from '../DynamicFormTypes';
import { useSectionData } from '../hooks/dataContext';
import GetFormElement from './GetFormElement';

export const GetForm = ({ getFormData }: DynamicFormTypes.IGetForm) => {
  const data = useSectionData();
  const { gatsbyPathName, tenantId } = data;
  const isMoveIn = gatsbyPathName.includes('move-in');
  let sectionConfig: DynamicFormTypes.TData[] = [];
  const { data: sectionFieldsData = {}, preFix = '' } = getFormData;

  // Converts the object of arrays into a single array
  const getReducedFieldsData = (
    fieldsData: any
  ): DynamicFormTypes.TFormField[] =>
    (Object.values(fieldsData) as DynamicFormTypes.TFormField[][]).reduce<
      DynamicFormTypes.TFormField[]
    >((acc, fields: DynamicFormTypes.TFormField[]) => {
      return [...acc, ...fields];
    }, []);

  switch (getFormData.label) {
    case 'Tenant Information':
      const {
        tenantAddress = [],
        tenantDriversLicenseInfo = [],
        tenantDOB = [],
        moveInDetails = [],
        ...tenantInfo // tenantName: [], tenantEmailDetails: [], tenantPhoneDetails: []
      } = sectionFieldsData;

      sectionConfig = [
        {
          heading: 'Tenant Information',
          data: [
            ...getReducedFieldsData(tenantInfo),
            ...(isMoveIn ? tenantDOB : []),
          ],
        },
        {
          heading: 'Address Details',
          data: tenantAddress,
        },
        {
          heading: 'ID Section',
          data: tenantDriversLicenseInfo,
        },
        {
          heading: 'Move-in date',
          data: moveInDetails,
        },
      ];
      break;
    case 'Alternate Contact':
      const {
        tenantAlternateAddress = [],
        ...tenantAlternateInfo // tenantAlternateName: [], tenantAlternatePhoneDetails: [], tenantAlternateEmailDetails: [], tenantAlternateRelationshipInfo: []
      } = sectionFieldsData;

      sectionConfig = [
        {
          heading: 'Alternate Contact Details',
          data: [...getReducedFieldsData(tenantAlternateInfo)],
        },
        {
          heading: 'Address Details',
          data: tenantAlternateAddress,
        },
      ];
      break;
    case 'Other Details':
      const {
        militaryInformation = [],
        AccountCreation = [],
      } = sectionFieldsData;
      sectionConfig = [
        {
          heading: 'Military Information',
          data: militaryInformation,
        },
      ];
      if (!tenantId) {
        sectionConfig.push({
          heading: 'Account Details',
          data: AccountCreation,
        });
      }
      break;
  }
  return (
    <>
      {sectionConfig.map((config: DynamicFormTypes.TData) => {
        const { heading, data: fieldsConfig = [] } = config;
        if (!fieldsConfig.length) {
          return <></>;
        }
        return (
          <div key={weakKey(config)} className="formSection">
            <h5 className="pb-5 mb-2">{heading}</h5>
            <Columns className="formFields">
              {fieldsConfig.map((fieldConfig: any = {}) => {
                const { label } = fieldConfig;
                const formikName = `${preFix}_${label.replace(
                  /[^A-Z0-9]/gi,
                  ''
                )}`;

                return (
                  <Column
                    className="inidividualFormField is-flex is-flex-direction-column is-flex-wrap-wrap"
                    key={label}
                    size={
                      formikName.includes('AddressLine1') ||
                      formikName.includes('Username')
                        ? 12
                        : 'half'
                    }
                  >
                    <>{GetFormElement(formikName, fieldConfig)}</>
                  </Column>
                );
              })}
            </Columns>
          </div>
        );
      })}
    </>
  );
};
